<template>
    <ds-dropdown
        disable-scroll
        icons
        :is-open="isActionDropdownOpen"
        @close="close"
        @change="focus"
    >
        <template #default>
            <ds-filled-button :trailing-icon="isActionDropdownOpen ? 'chevron-up' : 'chevron-down'" @click="toggleActionDropdown">
                <div>
                    {{ label }}
                </div>
            </ds-filled-button>
        </template>

        <template #menu>
            <ul slot="menu" class="dropdown-menu-list">
                <div v-for="category in $data.filteredQuickActions" :key="category.title">
                    <li class="dropdown-header">
                        {{ category.title }}
                    </li>
                    <li
                        v-for="entry in category.entries"
                        :key="entry.title"
                        class="dropdown-menu-item"
                        @click="entry.action === 'link' ? openLink(entry.link) : handleAction(entry.action)"
                    >
                        <ds-icon :name="entry.icon" />
                        {{ entry.title }}
                    </li>
                </div>
            </ul>
        </template>
    </ds-dropdown>
</template>

<script>

import ECOMM_QUICK_ACTIONS from './ecommQuickActions.json';

export default {

    ecommQuickActions: ECOMM_QUICK_ACTIONS,

    props: {
        checkoutPageLink: String,
        label: String,
        hideConvrrtCheckout: {
            type: Boolean,
            default: true,
        },
    },

    data() {
        return {
            searchInput: '',
            isActionDropdownOpen: false,
            filteredQuickActions: {},
        };
    },

    async mounted() {
        if (this.hideConvrrtCheckout) {
            this.filteredQuickActions = this.$options.ecommQuickActions.map((block) => {
                const { entries } = block;
                const filteredEntries = entries.filter((entry) => {
                    if (entry.action === 'createCheckoutPage') {
                        return false;
                    }

                    return true;
                });

                if (filteredEntries.length > 0) {
                    return {
                        title: block.title,
                        entries: filteredEntries,
                    };
                }

                return false;
            });
        } else {
            this.filteredQuickActions = this.$options.ecommQuickActions;
        }
    },

    methods: {
        close() {
            this.isActionDropdownOpen = false;
        },

        focus() {
            this.$emit('focus');
        },

        toggleActionDropdown() {
            this.isActionDropdownOpen = !this.isActionDropdownOpen;
        },

        openLink(url) {
            window.open(url, '_blank', 'noopener,noreferrer');
        },

        handleAction(action) {
            if (action === 'createCheckoutPage') {
                this.createCheckoutPage();
            }
        },

        createCheckoutPage() {
            this.openLink(this.checkoutPageLink);
        },
    },
};
</script>

<style lang="scss" scoped>

.dropdown-menu .icon {
    --icon-color: #000;
}

.dropdown-header {
    color:  rgba(0, 0, 0, 0.6);
    margin: 16px 0 0 16px;
}

.dropdown-menu-list {
    padding: 0;
}

.dropdown-reference .button {
    height:     40px;
    min-width:  140.75px;
}

</style>
